import { TableHeadersType } from "./tableHeadersType";

export const JOB_PROGRESS_HEADERS: TableHeadersType[] = [
  {
    "label": "Job Type",
    "value": "job_type",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Client Details",
    "value": "name",
    "defaultChecked": true,
    "checked": true
  },
  
  {
  
    "label": "Target End Date",
    "value": "target_end_date",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Currently Responsible",
    "value": "currently_responsible",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Job Manager",
    "value": "job_manager",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Charged VS Scheduled",
    "value": "charged_vs_scheduled",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Details",
    "value": "job_details",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Status",
    "value": "current_job_state",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Checklist Status",
    "value": "checklist_status",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Comment by",
    "value": "first_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Comment Details",
    "value": "comments",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Action",
    "value": "action",
    "defaultChecked": true,
    "checked": true
  }
];

export const JOB_TRACKER_HEADERS: TableHeadersType[] = [
  {
    "label": "Job Type",
    "value": "job_type",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Target End Date",
    "value": "target_end_date",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Currently Responsible",
    "value": "currently_responsible",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Job Manager",
    "value": "job_manager",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Details",
    "value": "job_details",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Status",
    "value": "current_job_state",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Comment by",
    "value": "first_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Comment Details",
    "value": "comments",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Action",
    "value": "action",
    "defaultChecked": true,
    "checked": true
  },
];

export const JOB_PENDING_APPROVAL_HEADERS: TableHeadersType[] = [
  {
    "label": "Job Type",
    "value": "job_type",
    "defaultChecked": true,
    "checked": true
  }, 
  {
    "label": "Client Details",
    "value": "client_code",
    "defaultChecked": true,
    "checked": true
  },
  
  {
  
    "label": "Target End Date",
    "value": "target_end_date",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Currently Responsible",
    "value": "currently_responsible",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Job Manager",
    "value": "job_manager",
    "defaultChecked": true,
    "checked": true
  },

  {
    "label": "Details",
    "value": "job_details",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Closure Status",
    "value": "internal_status",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Action",
    "value": "action",
    "defaultChecked": true,
    "checked": true
  },
  
 
  
];

export  const CHECKLIST_HEADER = [
  {
    label: "CheckList Name",
    value: "checklist_name",
  },
  {
    label: "CheckList Status",
    value: "checklist_status",
  },
  {
    label: "Action",
    value: "action",
  },
];

export const COMMENT_DUE_TOMORROW_HEADERS: TableHeadersType[] = [
  {
    "label": "Job Type",
    "value": "job_type",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Client Details",
    "value": "name",
    "defaultChecked": true,
    "checked": true
  },
  
  {
  
    "label": "Target End Date",
    "value": "target_end_date",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Currently Responsible",
    "value": "currently_responsible",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Job Manager",
    "value": "job_manager",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Charged VS Scheduled",
    "value": "charged_vs_scheduled",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Details",
    "value": "job_details",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Status",
    "value": "current_job_state",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Comment by",
    "value": "first_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Comment Details",
    "value": "comments",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Action",
    "value": "action",
    "defaultChecked": true,
    "checked": true
  }
];
